
  (function() {
    if (typeof HTMLInputElement !== 'undefined' && 'showPicker' in HTMLInputElement.prototype) {
      document.documentElement.classList.add('js-picker');
    }
    var opts = document.querySelectorAll('.fulfillment-option');
    var abholFields = document.getElementById('abholung-fields');
    var lieferHinweis = document.getElementById('lieferung-hinweis');
    var dateInput = document.getElementById('abholdatum');
    var timeInput = document.getElementById('abholuhrzeit');
    var hint = document.getElementById('cart-hint');
    var addButtons = document.querySelectorAll('.box-card');
    // Sorgt dafuer, dass Datum- und Uhrzeit-Auswahl sich gegenseitig schliessen.
    var picker = { schliesseZeit: null, schliesseDatum: null };
    // Vorlaufzeit: Abholung fruehestens X Stunden nach der Bestellung (Abschnitt „Donuts – Abholung“)
    var VORLAUF_H = parseFloat(abholFields ? abholFields.getAttribute('data-vorlauf') : '');
    if (isNaN(VORLAUF_H) || VORLAUF_H < 0) VORLAUF_H = 24;
    var ZEIT_VON = 11 * 60, ZEIT_BIS = 17 * 60, ZEIT_SCHRITT = 30;
    // Bestellpause: Zeitraum aus den Abschnitts-Einstellungen („Gesperrt von/bis“), Tage im Kalender grau
    function sperrDatum(s) {
      s = (s || '').trim();
      var m = /^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{2,4})$/.exec(s);
      if (m) { var j = parseInt(m[3], 10); if (j < 100) j += 2000; return new Date(j, parseInt(m[2], 10) - 1, parseInt(m[1], 10)); }
      m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s);
      return m ? new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10)) : null;
    }
    var SPERRE_VON = sperrDatum(abholFields ? abholFields.getAttribute('data-sperre-von') : '');
    var SPERRE_BIS = sperrDatum(abholFields ? abholFields.getAttribute('data-sperre-bis') : '');
    if (SPERRE_VON && !SPERRE_BIS) SPERRE_BIS = SPERRE_VON;
    if (SPERRE_BIS && !SPERRE_VON) SPERRE_VON = SPERRE_BIS;
    if (SPERRE_VON && SPERRE_BIS && SPERRE_VON > SPERRE_BIS) { var sp = SPERRE_VON; SPERRE_VON = SPERRE_BIS; SPERRE_BIS = sp; }
    function gesperrterTag(d) {
      if (!SPERRE_VON || !d) return false;
      var t = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
      return t >= SPERRE_VON.getTime() && t <= SPERRE_BIS.getTime();
    }
    function wochentagOk(d) { return d.getDay() >= 3 && d.getDay() <= 6 && !gesperrterTag(d); }
    function terminOk(d, minuten) {
      if (!d) return false;
      return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, minuten).getTime() >= Date.now() + VORLAUF_H * 3600000;
    }
    function leseDatum() {
      var m = dateInput && /^(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})$/.exec(dateInput.value.trim());
      return m ? new Date(parseInt(m[3], 10), parseInt(m[2], 10) - 1, parseInt(m[1], 10)) : null;
    }
    function leseZeit() {
      var m = timeInput && /^(\d{1,2}):(\d{2})$/.exec(timeInput.value.trim());
      return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null;
    }
    function hinweisZeigen() {
      var h = document.getElementById('vorlauf-hinweis');
      if (!h) return;
      h.classList.remove('nd-wackeln'); void h.offsetWidth; h.classList.add('nd-wackeln');
    }
    function leereZeit() {
      if (!timeInput) return;
      timeInput.value = '';
      var w = document.getElementById('abholuhrzeit-wert'); if (w) w.value = '';
    }
    // Gespeicherte oder inzwischen zu knappe Termine verwerfen
    function pruefeTermin() {
      var d = leseDatum(), z = leseZeit(), weg = false;
      if (d && (!wochentagOk(d) || !terminOk(d, ZEIT_BIS))) {
        dateInput.value = ''; var w = document.getElementById('abholdatum-wert'); if (w) w.value = '';
        leereZeit(); weg = true;
      } else if (d && z !== null && !terminOk(d, z)) { leereZeit(); weg = true; }
      if (weg) { hinweisZeigen(); updateHint(); }
      return !weg;
    }
    window.NadosAbholTermin = { pruefen: function () { return pruefeTermin(); }, vorlauf: VORLAUF_H };

    function mode() {
      var active = document.querySelector('.fulfillment-option.active');
      return active ? active.getAttribute('data-fulfillment') : 'abholung';
    }
    function pickupReady() {
      return !!(dateInput && timeInput && dateInput.value && timeInput.value);
    }
    function updateHint() {
      if (window.NadosCart && window.NadosCart.info) window.NadosCart.info();
      if (hint) hint.style.display = !pickupReady() ? 'block' : 'none';
    }
    function applyMode() {
      var m = mode();
      if (abholFields) { abholFields.style.display = 'block'; abholFields.setAttribute('data-modus', m === 'lieferung' ? 'lieferung' : 'abholung'); }
      if (lieferHinweis) lieferHinweis.style.display = (m === 'lieferung') ? 'block' : 'none';
      updateHint();
    }

    // Springt bei "Abholung" ohne Datum/Uhrzeit automatisch zum entsprechenden
    // Bereich und hebt das fehlende Feld hervor. Nutzt eine manuell berechnete
    // Sprungposition statt scrollIntoView({behavior:'smooth'}), weil einige
    // mobile Browser diese Options-Variante nicht unterstuetzen und den Aufruf
    // dann stillschweigend ignorieren (kein Sprung, kein Fehler).
    function scrolleZuFeld(el) {
      if (!el) return;
      var zielY = null;
      try {
        var rect = el.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        zielY = rect.top + scrollTop - Math.max((window.innerHeight - rect.height) / 2, 12);
        if (zielY < 0) zielY = 0;
      } catch (e) { zielY = null; }

      if (zielY === null) {
        try { el.scrollIntoView(); } catch (e2) {}
        return;
      }
      try {
        window.scrollTo({ top: zielY, left: 0, behavior: 'smooth' });
      } catch (e3) {
        window.scrollTo(0, zielY);
      }
    }

    function erinnereFehlendeAbholzeit() {
      var missing = (dateInput && !dateInput.value) ? dateInput : timeInput;
      scrolleZuFeld(abholFields || missing);
      if (missing) {
        missing.classList.add('field-error');
        missing.classList.remove('field-shake');
        void missing.offsetWidth;
        missing.classList.add('field-shake');
        setTimeout(function () {
          try { missing.focus({ preventScroll: true }); } catch (err) { /* Fokus ohne Sprung wird nicht ueberall unterstuetzt – dann bleibt einfach unser Sprung von oben bestehen */ }
        }, 500);
      }
    }

    // Warenkorb-Buttons werden bewusst ganz oben gebunden, noch bevor die
    // Kalender-/Uhrzeit-Widgets unten initialisiert werden: so funktioniert
    // "In den Warenkorb" immer, selbst wenn eines dieser Widgets auf einem
    // Geraet aus irgendeinem Grund nicht sauber laden sollte.
    addButtons.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-soldout')) return;
        if (!pickupReady()) {
          erinnereFehlendeAbholzeit();
          return;
        }
        if (window.NadosBox) window.NadosBox.open(card);
      });
    });

    // Abhol-/Lieferdaten als Line-Item-Properties (wird von der Box-Auswahl beim Hinzufuegen genutzt)
    window.NadosFulfillmentProps = function () {
      var p = {};
      if (mode() === 'abholung') {
        p['Lieferart'] = 'Abholung am ' + (dateInput ? dateInput.value : '') + ' um ' + (timeInput ? timeInput.value : '') + ' Uhr';
      } else {
        p['Lieferart'] = 'Lieferung am ' + (dateInput ? dateInput.value : '') + ' um ' + (timeInput ? timeInput.value : '') + ' Uhr';
      }
      return p;
    };

    opts.forEach(function(opt) {
      opt.addEventListener('click', function() {
        opts.forEach(function(o) { o.classList.remove('active'); });
        opt.classList.add('active');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        applyMode();
      });
    });

    // ---- Eigene Abholzeit-Auswahl: auf jedem Geraet identisch ----
    try { (function () {
      var anzeige = timeInput;
      var wert = document.getElementById('abholuhrzeit-wert');
      var pop = document.getElementById('abholuhrzeit-liste');
      if (!anzeige || !pop) return;
      var VON = ZEIT_VON, BIS = ZEIT_BIS, SCHRITT = ZEIT_SCHRITT;

      var html = '';
      for (var m = VON; m <= BIS; m += SCHRITT) {
        var t = String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
        html += '<button type="button" class="time-opt" role="option" data-zeit="' + t + '">' + t + '</button>';
      }
      pop.innerHTML = html;

      function markiere() {
        var opts = pop.querySelectorAll('.time-opt');
        var tag = leseDatum();
        Array.prototype.forEach.call(opts, function (o) {
          var zt = o.getAttribute('data-zeit').split(':');
          o.disabled = !!tag && !terminOk(tag, parseInt(zt[0], 10) * 60 + parseInt(zt[1], 10));
          var aktiv = o.getAttribute('data-zeit') === anzeige.value;
          o.classList.toggle('gewaehlt', aktiv);
          o.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        });
      }
      function oeffne() {
        if (picker.schliesseDatum) picker.schliesseDatum();
        markiere();
        pop.hidden = false;
        anzeige.setAttribute('aria-expanded', 'true');
        var akt = pop.querySelector('.time-opt.gewaehlt');
        if (!akt) akt = pop.querySelector('.time-opt:not(:disabled)');
        pop.scrollTop = akt ? Math.max(0, akt.offsetTop - pop.clientHeight / 2 + akt.offsetHeight / 2) : 0;
      }
      function schliesse() {
        pop.hidden = true;
        anzeige.setAttribute('aria-expanded', 'false');
      }
      picker.schliesseZeit = schliesse;

      anzeige.addEventListener('click', function (e) {
        e.stopPropagation();
        if (pop.hidden) oeffne(); else schliesse();
      });
      var lbl = document.querySelector('label[for="abholuhrzeit"]');
      if (lbl) lbl.addEventListener('click', function (e) { e.preventDefault(); anzeige.focus(); oeffne(); });

      pop.addEventListener('click', function (e) {
        e.stopPropagation();
        var b = e.target.closest('button[data-zeit]');
        if (!b) return;
        if (b.disabled) { hinweisZeigen(); return; }
        anzeige.value = b.getAttribute('data-zeit');
        if (wert) wert.value = anzeige.value;
        anzeige.classList.remove('field-error');
        schliesse();
        updateHint();
      });
      document.addEventListener('click', function () { if (!pop.hidden) schliesse(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) schliesse(); });
    })(); } catch (e) { /* Zeitauswahl konnte nicht initialisiert werden */ }

    // ---- Eigener Kalender: nicht verfuegbare Tage grau, heute lila ----
    var oeffneKalender = null;
    try { (function() {
      var anzeige = dateInput;
      var wert = document.getElementById('abholdatum-wert');
      var pop = document.getElementById('abholdatum-kalender');
      if (!anzeige || !pop) return;
      var gitter = pop.querySelector('.cal-grid');
      var titel = pop.querySelector('.cal-title');
      var btnZurueck = pop.querySelector('[data-cal-prev]');
      var btnVor = pop.querySelector('[data-cal-next]');
      var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
      var nd_mon = (window.NadosTexte && typeof window.NadosTexte.__monate === 'string') ? window.NadosTexte.__monate.split(',') : [];
      if (nd_mon.length === 12) MONATE = nd_mon.map(function (x) { return x.trim(); });
      var heute = new Date(); heute.setHours(0, 0, 0, 0);
      var gewaehlt = null;
      var sicht = new Date(heute.getFullYear(), heute.getMonth(), 1);

      function zz(n) { return String(n).padStart(2, '0'); }
      function iso(d) { return d.getFullYear() + '-' + zz(d.getMonth() + 1) + '-' + zz(d.getDate()); }
      function uebersetze(s) { return (window.NadosI18n ? window.NadosI18n.t(s) : s); }
      function trenner() { return (window.NadosI18n && window.NadosI18n.get() === 'en') ? '/' : '.'; }
      function deutsch(d) { var s = trenner(); return zz(d.getDate()) + s + zz(d.getMonth() + 1) + s + d.getFullYear(); }
      function verfuegbar(d) { return wochentagOk(d) && terminOk(d, ZEIT_BIS); }

      function zeichne() {
        titel.textContent = uebersetze(MONATE[sicht.getMonth()]) + ' ' + sicht.getFullYear();
        var versatz = (new Date(sicht.getFullYear(), sicht.getMonth(), 1).getDay() + 6) % 7;
        var tage = new Date(sicht.getFullYear(), sicht.getMonth() + 1, 0).getDate();
        var html = '';
        for (var i = 0; i < versatz; i++) html += '<span class="cal-day leer"></span>';
        for (var t = 1; t <= tage; t++) {
          var d = new Date(sicht.getFullYear(), sicht.getMonth(), t);
          var kl = 'cal-day';
          if (d.getTime() === heute.getTime()) kl += ' heute';
          if (gewaehlt && d.getTime() === gewaehlt.getTime()) kl += ' gewaehlt';
          html += '<button type="button" class="' + kl + '" data-datum="' + iso(d) + '"' +
                  (verfuegbar(d) ? '' : ' disabled') + '>' + t + '</button>';
        }
        gitter.innerHTML = html;
        btnZurueck.disabled = (sicht.getFullYear() === heute.getFullYear() && sicht.getMonth() === heute.getMonth());
      }

      function oeffne() {
        if (picker.schliesseZeit) picker.schliesseZeit();
        heute = new Date(); heute.setHours(0, 0, 0, 0);
        if (!gewaehlt || !anzeige.value) gewaehlt = leseDatum();
        sicht = gewaehlt ? new Date(gewaehlt.getFullYear(), gewaehlt.getMonth(), 1)
                         : new Date(heute.getFullYear(), heute.getMonth(), 1);
        zeichne();
        pop.hidden = false;
        anzeige.setAttribute('aria-expanded', 'true');
      }
      function schliesse() {
        pop.hidden = true;
        anzeige.setAttribute('aria-expanded', 'false');
      }
      oeffneKalender = oeffne;
      picker.schliesseDatum = schliesse;

      anzeige.addEventListener('click', function(e) {
        e.stopPropagation();
        if (pop.hidden) oeffne(); else schliesse();
      });
      var lbl = document.querySelector('label[for="abholdatum"]');
      if (lbl) lbl.addEventListener('click', function(e) { e.preventDefault(); anzeige.focus(); oeffne(); });

      btnZurueck.addEventListener('click', function(e) {
        e.stopPropagation();
        sicht = new Date(sicht.getFullYear(), sicht.getMonth() - 1, 1);
        zeichne();
      });
      btnVor.addEventListener('click', function(e) {
        e.stopPropagation();
        sicht = new Date(sicht.getFullYear(), sicht.getMonth() + 1, 1);
        zeichne();
      });

      gitter.addEventListener('click', function(e) {
        var b = e.target.closest('button[data-datum]');
        if (!b || b.disabled) return;
        var t = b.getAttribute('data-datum').split('-');
        gewaehlt = new Date(parseInt(t[0], 10), parseInt(t[1], 10) - 1, parseInt(t[2], 10));
        anzeige.value = deutsch(gewaehlt);
        if (wert) wert.value = iso(gewaehlt);
        anzeige.classList.remove('field-error');
        var zt = leseZeit();
        if (zt !== null && !terminOk(gewaehlt, zt)) { leereZeit(); hinweisZeigen(); }
        schliesse();
        updateHint();
      });

      pop.addEventListener('click', function(e) { e.stopPropagation(); });
      document.addEventListener('click', function() { if (!pop.hidden) schliesse(); });
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && !pop.hidden) schliesse(); });
      document.addEventListener('nados:lang', function() {
        if (gewaehlt) anzeige.value = deutsch(gewaehlt);
        if (!pop.hidden) zeichne();
      });
    })(); } catch (e) { /* Kalender konnte nicht initialisiert werden */ }
    // Vor jeder Aktion (Box waehlen, Warenkorb, Kasse) Termin pruefen
    document.addEventListener('click', function () { try { pruefeTermin(); } catch (e) {} }, true);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { try { pruefeTermin(); } catch (e) {} } });

    // ---- Farbverlauf der Kacheln automatisch aus dem jeweiligen Bild ableiten ----
    try { (function () {
      var karten = document.querySelectorAll('.donut-grid-card');
      if (!karten.length) return;

      function setzeFarbe(karte, img) {
        try {
          var bw = 32, bh = 42;
          var c = document.createElement('canvas');
          c.width = bw; c.height = bh;
          var ctx = c.getContext('2d');
          if (!ctx) return;
          ctx.drawImage(img, 0, 0, bw, bh);
          var ab = Math.floor(bh * 0.5);                 // untere Bildhaelfte, dort liegt der Verlauf
          var d = ctx.getImageData(0, ab, bw, bh - ab).data;
          var r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
          if (!n) return;
          r /= n; g /= n; b /= n;
          var mit = (r + g + b) / 3;                     // Farbton etwas kraeftiger
          r = mit + (r - mit) * 1.35;
          g = mit + (g - mit) * 1.35;
          b = mit + (b - mit) * 1.35;
          r = r + (255 - r) * 0.20;                      // aufhellen statt abdunkeln
          g = g + (255 - g) * 0.20;
          b = b + (255 - b) * 0.20;
          var kappen = function (x) { return Math.max(0, Math.min(255, Math.round(x))); };
          r = kappen(r); g = kappen(g); b = kappen(b);
          karte.style.setProperty('--kachel-rgb', r + ' ' + g + ' ' + b);

          // Schriftfarbe nach dem tatsaechlich besseren Kontrast waehlen
          var linear = function (x) {
            x = x / 255;
            return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
          };
          var leucht = function (a) { return 0.2126 * linear(a[0]) + 0.7152 * linear(a[1]) + 0.0722 * linear(a[2]); };
          var verhaeltnis = function (a, c) {
            var l1 = Math.max(leucht(a), leucht(c)), l2 = Math.min(leucht(a), leucht(c));
            return (l1 + 0.05) / (l2 + 0.05);
          };
          var grund = [r, g, b];
          var hell = verhaeltnis(grund, [26, 20, 16]) >= verhaeltnis(grund, [255, 255, 255]);
          if (hell) {
            karte.style.setProperty('--kachel-text', '#3d1a45');
            karte.style.setProperty('--kachel-text-weich', 'rgb(61 26 69 / 0.78)');
            karte.style.setProperty('--kachel-chip-bg', 'rgb(255 255 255 / 0.62)');
            karte.style.setProperty('--kachel-chip-text', '#3d1a45');
            karte.style.setProperty('--kachel-btn-bg', '#3d1a45');
            karte.style.setProperty('--kachel-btn-text', '#ffffff');
            karte.style.setProperty('--kachel-schatten', 'rgb(255 255 255 / 0.8)');
          } else {
            karte.style.setProperty('--kachel-text', '#ffffff');
            karte.style.setProperty('--kachel-text-weich', 'rgb(255 255 255 / 0.86)');
            karte.style.setProperty('--kachel-chip-bg', 'rgb(61 26 69 / 0.42)');
            karte.style.setProperty('--kachel-chip-text', '#ffffff');
            karte.style.setProperty('--kachel-btn-bg', '#3d1a45');
            karte.style.setProperty('--kachel-btn-text', '#ffffff');
            karte.style.setProperty('--kachel-schatten', 'rgb(26 20 16 / 0.7)');
          }
        } catch (err) { /* Standardfarbe bleibt stehen */ }
      }

      Array.prototype.forEach.call(karten, function (karte) {
        var img = karte.querySelector('img');
        if (!img) return;
        if (img.complete && img.naturalWidth) setzeFarbe(karte, img);
        else img.addEventListener('load', function () { setzeFarbe(karte, img); });
      });
    })(); } catch (e) { /* Kachelfarben konnten nicht berechnet werden */ }

    applyMode();

    var chips = document.querySelectorAll('#donut-filter .filter-chip');
    var cards = document.querySelectorAll('.donut-grid .donut-grid-card');
    var emptyNote = document.getElementById('filter-empty');

    function applyFilter(cat) {
      var visible = 0;
      cards.forEach(function(card) {
        var match = (cat === 'alle') || (card.getAttribute('data-cat') === cat);
        card.style.display = match ? 'flex' : 'none';
        if (match) visible++;
      });
      if (emptyNote) emptyNote.style.display = visible === 0 ? 'block' : 'none';
    }
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) { c.classList.remove('active'); });
        chip.classList.add('active');
        applyFilter(chip.getAttribute('data-filter'));
      });
    });
    applyFilter('alle');
  })();
  
